{
    "firebase": {
        "apiKey": "AIzaSyBXQ3qopVPLyq7E-_XjxM0OMFbag4gVgLo",
        "authDomain": "flightline-app-376e7.firebaseapp.com",
        "databaseURL": "https://flightline-app-376e7-default-rtdb.firebaseio.com",
        "projectId": "flightline-app-376e7",
        "storageBucket": "flightline-app-376e7.firebasestorage.app",
        "messagingSenderId": "994126870498",
        "appId": "1:994126870498:web:35b6bcddd97e3c7471abbb"
    },
    "clientName": "Flightline App",
    "pdfViewerKey": "cc51d841a3634b5e87766058aec564bd",
    "domains": ["app.flightlinedata.com"],
    "tally_url": ""
}
